/* import __COLOCATED_TEMPLATE__ from './select-kit-collection.hbs'; */
import { cached } from "@glimmer/tracking";
import Component from "@ember/component";
import { action } from "@ember/object";
import { tagName } from "@ember-decorators/component";
import { disableBodyScroll, enableBodyScroll } from "discourse/lib/body-scroll-lock";
const SelectKitCollection = dt7948.c(class SelectKitCollection extends Component {
  get inModal() {
    const element = this.selectKit.mainElement();
    return element.closest(".d-modal");
  }
  static {
    dt7948.n(this.prototype, "inModal", [cached]);
  }
  lock(element) {
    if (!this.inModal) {
      return;
    }
    disableBodyScroll(element);
  }
  static {
    dt7948.n(this.prototype, "lock", [action]);
  }
  unlock(element) {
    enableBodyScroll(element);
  }
  static {
    dt7948.n(this.prototype, "unlock", [action]);
  }
}, [tagName("")]);
export default SelectKitCollection;